import { html } from "lit";

export default (o) => {
    const date = new Date(o.time);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-GB', options);

    return html`<div class="message date-separator" data-isodate="${o.time}"><time class="separator-text" datetime="${o.time}"><span>${formattedDate}</span></time></div>`;
}
